<div [formGroup]="form">
  <section class="general-info">
    <div class="flex-row-generic">
      <!-- External Id Control -->
      <div class="form-group flex-item-three-columns">
        <label
        for="{{ baseId }}-id"
        translate
        >ID</label>
        <input
        id="{{ baseId }}-id"
        class="form-control"
        [ngClass]="{ error: showErrors(externalIdControl, isSubmitted),'required': isRequired(externalIdControl) }"
        type="text"
        [maxlength]="fcListValidation.validations.ExternalID.MaxLength"
        formControlName="externalId"
        />
        <div
        *ngIf="showErrors(externalIdControl, isSubmitted)"
        id="{{ baseId }}-warning-text-id"
        class="incorrect-input"
        translate
      >
      {{ externalIdControl.errors | fcListValidation : 'ID' }}
    </div>
  </div>
  <!-- External Id Control -->

  <!-- Name Control -->
  <div class="form-group flex-item-three-columns">
      <label
      for="{{ baseId }}-name"
      translate
      >Name</label>
      <input
      id="{{ baseId }}-name"
      class="form-control"
      [ngClass]="{ error: showErrors(nameControl, isSubmitted), 'required': isRequired(nameControl) }"
      type="text"
      [maxlength]="fcListValidation.validations.Name.MaxLength"
      formControlName="name"
      />
      <div
        *ngIf="showErrors(nameControl, isSubmitted)"
        id="{{ baseId }}-warning-text-name"
        class="incorrect-input"
        translate
      >
        {{ nameControl.errors | fcListValidation : 'Name' }}
      </div>
    </div>
    <!-- Name Control -->

    <!-- Primary Contact Control -->
    <div class="form-group flex-item-three-columns">
      <label
      for="{{ baseId }}-primary-contact"
      translate
      >Primary Contact</label>
      <input
      id="{{ baseId }}-primary-contact"
      class="form-control"
      [ngClass]="{ error: showErrors(primaryContactControl, isSubmitted), 'required': isRequired(primaryContactControl) }"
      type="text"
      [maxlength]="fcListValidation.validations.Contact.MaxLength"
      formControlName="primaryContact"
      />
      <div
      *ngIf="showErrors(primaryContactControl, isSubmitted)"
      id="{{ baseId }}-warning-text-primary-contact"
      class="incorrect-input"
      translate
      >
      {{ primaryContactControl.errors | fcListValidation : 'Primary Contact' }}
    </div>
  </div>
  <!-- Primary Contact Control -->
</div>

<div class="flex-row-generic">
  <!-- Secondary Contact Control -->
  <div class="form-group flex-item-three-columns">
    <label
    for="{{ baseId }}-secondary-contact"
    translate
    >Secondary Contact</label>
    <input
    id="{{ baseId }}-secondary-contact"
    class="form-control"
    [ngClass]="{ error: showErrors(secondaryContactControl, isSubmitted), 'required': isRequired(secondaryContactControl) }"
    type="text"
    [maxlength]="fcListValidation.validations.Contact.MaxLength"
    formControlName="secondaryContact"
    />
    <div
    *ngIf="showErrors(secondaryContactControl, isSubmitted)"
    id="{{ baseId }}-warning-text-secondary-contact"
    class="incorrect-input"
    translate
    >
    {{ secondaryContactControl.errors | fcListValidation : 'Secondary Contact' }}
  </div>
</div>
<!-- Secondary Contact Control -->
</div>
  </section>

  <hr />
  <h4
    id="{{ baseId }}-address-subtitle"
    translate
  >Address</h4>
  <!-- Address Group -->
  <fc-address-list
    [baseId]="baseId + 'address'"
    [form]="addressGroup"
    [listItem]="listItem?.Address"
    [isSubmitted]="isSubmitted"
    [itemContext]="itemContext"
    (areaCode)="onSetAreaCode($event)"
  ></fc-address-list>
  <!-- Address Group -->

  <hr />
  <h4
    id="{{ baseId }}-contact-information-subtitle"
    translate
  >Contact Information</h4>

  <!-- Contact Information Group -->
  <section class="contact-information">
    <div class="phone-one">
      <fc-phone-number-list
        [baseId]="baseId"
        [form]="phoneOneGroup"
        [listItem]="listItem?.Phone1"
        [isSubmitted]="isSubmitted"
        [itemContext]="itemContext"
        [index]="1"
      ></fc-phone-number-list>
    </div>
    <div class="phone-two">
      <fc-phone-number-list
        [baseId]="baseId"
        [form]="phoneTwoGroup"
        [listItem]="listItem?.Phone2"
        [isSubmitted]="isSubmitted"
        [itemContext]="itemContext"
        [index]="2"
      ></fc-phone-number-list>
    </div>
    <div class="phone-three">
      <fc-phone-number-list
        [baseId]="baseId"
        [form]="phoneThreeGroup"
        [listItem]="listItem?.Phone3"
        [isSubmitted]="isSubmitted"
        [itemContext]="itemContext"
        [index]="3"
      ></fc-phone-number-list>
    </div>
    <div class="phone-four">
      <fc-phone-number-list
        [baseId]="baseId"
        [form]="phoneFourGroup"
        [listItem]="listItem?.Phone4"
        [isSubmitted]="isSubmitted"
        [itemContext]="itemContext"
        [index]="4"
      ></fc-phone-number-list>
    </div>
    <!-- Contact Information Group -->

    <ng-container *ngIf="emailControlsEnabled">
      <div class="flex-row-generic">
        <!-- Email 1 Control -->
        <div class="form-group flex-item-two-columns">
          <label
          for="{{ baseId }}-email-one"
          translate
          >Email 1</label>
          <input
          id="{{ baseId }}-email-one"
          class="form-control"
          [ngClass]="{ error: showErrors(emailOneControl, isSubmitted), 'required': isRequired(emailOneControl) }"
          type="text"
          [maxlength]="fcListValidation.validations.Email.MaxLength"
          formControlName="emailOne"
          />
          <div
          *ngIf="showErrors(emailOneControl, isSubmitted)"
          id="{{ baseId }}-warning-text-email-one"
          class="incorrect-input"
          translate
          >
          {{ emailOneControl.errors | fcListValidation : 'Email 1' }}
        </div>
      </div>
      <!-- Email 1 Control -->

      <!-- Email 2 Control -->
      <div class="form-group flex-item-two-columns">
        <label
          for="{{ baseId }}-email-two"
          translate
        >Email 2</label>
        <input
        id="{{ baseId }}-email-two"
        class="form-control"
        [ngClass]="{ error: showErrors(emailTwoControl, isSubmitted), 'required': isRequired(emailTwoControl) }"
        type="text"
        [maxlength]="fcListValidation.validations.Email.MaxLength"
          formControlName="emailTwo"
          />
          <div
          *ngIf="showErrors(emailTwoControl, isSubmitted)"
          id="{{ baseId }}-warning-text-email-two"
          class="incorrect-input"
          translate
          >
          {{ emailTwoControl.errors | fcListValidation : 'Email 2' }}
        </div>
      </div>
      <!-- Email 2 Control -->
    </div>
    </ng-container>
  </section>
</div>
